import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mb-3",
  style: {"margin-top":"1.5rem"}
}
const _hoisted_2 = { style: {"float":"right"} }
const _hoisted_3 = { style: {"color":"#286ef1","font-size":"1rem","padding-right":"1rem"} }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mt-2"
}, "登录", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_validate_form = _resolveComponent("validate-form")!

  return (_openBlock(), _createBlock(_component_validate_form, { onFormSubmit: _ctx.onFormSubmit }, {
    submit: _withCtx(() => [
      _hoisted_5
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_validate_input, {
          class: "form-control",
          rules: _ctx.mobileRules,
          modelValue: _ctx.mobileValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mobileValue) = $event)),
          placeholder: "请输入手机号码",
          type: "text"
        }, null, 8, ["rules", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCountDownClick && _ctx.onCountDownClick(...args)))
          }, "获取验证码", 512), [
            [_vShow, !_ctx.countDown]
          ]),
          _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.count) + " 秒", 513), [
            [_vShow, _ctx.countDown]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_validate_input, {
          class: "form-control",
          rules: _ctx.codeRules,
          modelValue: _ctx.codeValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.codeValue) = $event)),
          placeholder: "请输入短信验证码",
          type: "password"
        }, null, 8, ["rules", "modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["onFormSubmit"]))
}